export default function initFormulaireCF7Confirmation() {
    const $formConfirmation = document.querySelectorAll<HTMLElement>('.js-wpcf7-form-with-confirmation');
    $formConfirmation.forEach($container => {
        new FormConfirmation($container);
    });
}


export class FormConfirmation {
    $el: HTMLElement | null | undefined;
    $form: HTMLFormElement | null | undefined;
    $confirmation: HTMLElement | null | undefined;
   
    constructor($el: HTMLElement | null) {
        this.$el = $el;
        this.$form = $el?.querySelector('form');
        this.$confirmation = $el?.querySelector('.confirmation');
        this.init();
    }

    init(): void {
        const wpcf7Elm = this.$form;
        
        wpcf7Elm?.addEventListener('wpcf7mailsent', () => {
            wpcf7Elm.remove();
            this.$confirmation?.classList.add('visible');
        });
    }
}